import React, { useEffect, useState } from "react";
import { fetchClubTeams } from "../ServiceApi";
import "./SectionsPage.css";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";

const SectionsPage = () => {
    const [teams, setTeams] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const clubId = 137104; // ID du club
            const teamsData = await fetchClubTeams(clubId);

            // Mise à jour des noms pour différencier les équipes
            const updatedTeams = teamsData
                .filter(team =>
                    team.engagements &&
                    team.engagements.length > 0 &&
                    team.engagements.some(e => e.competitionType === "CH") // Vérifie si au moins un engagement a type "CH"
                )
                .map(team => {
                    let teamName = team.name.replace("Futsal", "").trim();

                    // Différencier les équipes séniors
                    if (team.category === "SESM") {
                        const isRegional1 = team.engagements.some(e => e.competitionName === "Régional 1 Futsal");
                        const isRegional2 = team.engagements.some(e => e.competitionName === "Régional 2 Futsal");
                        const isDepartmental1 = team.engagements.some(e => e.competitionName === "Départemental 1 Futsal Masculin");

                        if (isRegional1) {
                            teamName = "Sénior 1";
                        } else if (isRegional2) {
                            teamName = "Sénior 2";
                        } else if (isDepartmental1) {
                            teamName = "Sénior 3";
                        }
                    }

                    return {
                        ...team,
                        displayName: teamName,
                    };
                });

            const duplicatedTeams = updatedTeams.flatMap(team => {
                if (team.displayName === "U15 - U14") {
                    return [
                        { ...team, displayName: "U15 - U14 A" },
                        { ...team, displayName: "U15 - U14 B"}
                    ];
                }
                return [team]; // Retourne les équipes normales
            });

            // Ajout des catégories statiques
            const staticCategories = [
                { id: "static-baby", displayName: "Baby U7-U9" },
                { id: "static-feminine", displayName: "Féminine" }
            ];

            const allTeams = [...duplicatedTeams, ...staticCategories];

            // Supprime les doublons (hors séniors)
            const uniqueTeams = [];
            const seenCategories = new Set();

            allTeams.forEach(team => {
                const categoryKey = team.displayName;

                if (!seenCategories.has(categoryKey)) {
                    seenCategories.add(categoryKey);
                    uniqueTeams.push(team);
                }
            });

            // Trier les équipes
            const sortedTeams = sortTeams(uniqueTeams);
            setTeams(sortedTeams);
        };

        fetchData();
    }, []);

    const navigateToTeamPage = (team) => {
        // Bloquer la redirection pour "Baby U7-U9" et "Féminine"
        if (team.displayName === "Baby U7-U9" || team.displayName === "Féminine") {
            alert(`Les informations pour "${team.displayName}" ne sont pas disponibles pour l'instant.`);
            return;
        }
         console.log("team", team);
        const numericId = extractNumericId(team.id);
        if (numericId) {
            if (numericId === 1) {
                navigate('/equipe-premiere');
            } else {
                navigate(`/team/${numericId}`, { state: { team } }); // Redirige vers la page de l'équipe
            }
        } else {
            console.error("Invalid team ID:", team.id);
        }
    };

    const extractNumericId = (teamId) => {
        // Utilise une expression régulière pour trouver les chiffres à la fin de la chaîne
        const match = teamId.match(/\/(\d+)$/);
        return match ? parseInt(match[1], 10) : null; // Convertit le résultat en nombre ou retourne null si pas trouvé
    };

    // Fonction pour obtenir l'image avec fallback
    const getTeamImage = (displayName) => {
        try {
            return require(`../assets/images/sections/${displayName}.jpg`);
        } catch (error) {
            console.error(`Image not found for team: ${displayName}. Using default image.`);
            return require("../assets/images/sections/default.jpg"); // Image par défaut
        }
    };

    // Fonction de tri par catégorie
    const sortTeams = (teams) => {
        const order = [
            "Sénior 1", "Sénior 2", "Sénior 3", "Sénior", // Les équipes Seniors
            "U19 - U18", "U17 - U16",                     // Catégories adolescentes
            "U15 - U14 A", "U15 - U14 B",                // Catégories jeunes (A et B)
            "U13 - U12",                                  // Plus jeunes catégories
            "Baby U7-U9", "Féminine"                     // Catégories statiques
        ];

        return teams.sort((a, b) => {
            const aIndex = order.indexOf(a.displayName);
            const bIndex = order.indexOf(b.displayName);

            // Si l'une des catégories n'est pas trouvée dans l'ordre, elle est placée en fin de liste
            return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
        });
    };


    return (
        <div className="sections-container">
            <h2 className="sections-title">Sections du Club</h2>
            <div className="team-grid">
                {teams.length > 0 ? (
                    teams.map(team => (
                        <div
                            key={team.id}
                            className="team-card"
                            onClick={() => navigateToTeamPage(team)}
                        >
                            <img
                                src={getTeamImage(team.displayName)} // Utilise la fonction avec fallback
                                alt={team.displayName}
                                className="team-card-image"
                            />
                            <div className="team-card-name">{team.displayName}</div>
                        </div>

                    ))
                ) : (
                    <div className="loading-container">
                        <LoadingSpinner />
                    </div>
                )}
            </div>
        </div>
    );
};

export default SectionsPage;
